module.exports = __webpack_public_path__ + "img/icon_gerenciamento_de_comunicacoes.ee59979d.svg";